/*
 * Copyright (C) 2021 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

export enum TSUnterhaltsvereinbarungAnswer {
    JA_UNTERHALTSVEREINBARUNG = 'JA_UNTERHALTSVEREINBARUNG',
    NEIN_UNTERHALTSVEREINBARUNG = 'NEIN_UNTERHALTSVEREINBARUNG',
    UNTERHALTSVEREINBARUNG_NICHT_MOEGLICH = 'UNTERHALTSVEREINBARUNG_NICHT_MOEGLICH'
}

export function getTSUnterhaltsvereinbarungAnswerValues(): Array<TSUnterhaltsvereinbarungAnswer> {
    return [
        TSUnterhaltsvereinbarungAnswer.JA_UNTERHALTSVEREINBARUNG,
        TSUnterhaltsvereinbarungAnswer.NEIN_UNTERHALTSVEREINBARUNG,
        TSUnterhaltsvereinbarungAnswer.UNTERHALTSVEREINBARUNG_NICHT_MOEGLICH
    ];
}
